import { render, staticRenderFns } from "./BaseAlbumScroll.vue?vue&type=template&id=aa5a61fc&scoped=true&"
import script from "./BaseAlbumScroll.vue?vue&type=script&lang=js&"
export * from "./BaseAlbumScroll.vue?vue&type=script&lang=js&"
import style0 from "./BaseAlbumScroll.vue?vue&type=style&index=0&id=aa5a61fc&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa5a61fc",
  null
  
)

export default component.exports